import api from './api'
import type { ContactMessage, ContactInfo, NewsletterSubscription, ContactFormData, NewsletterFormData } from '@/types'

export const contactService = {
  // Get contact info
  getContactInfo: async (): Promise<ContactInfo> => {
    const response = await api.get('/contact/info/active/')
    return response.data
  },

  // Send contact message
  sendContactMessage: async (data: ContactFormData): Promise<ContactMessage> => {
    const formData = new FormData()
    formData.append('name', data.name)
    formData.append('email', data.email)
    formData.append('company', data.company)
    formData.append('phone', data.phone)
    formData.append('subject', data.subject)
    formData.append('message', data.message)
    
    if (data.attachment) {
      formData.append('attachment', data.attachment)
    }

    const response = await api.post('/contact/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },

  // Subscribe to newsletter
  subscribeNewsletter: async (data: NewsletterFormData): Promise<NewsletterSubscription> => {
    const response = await api.post('/contact/newsletter/', data)
    return response.data
  },

  // Unsubscribe from newsletter
  unsubscribeNewsletter: async (email: string): Promise<void> => {
    await api.post('/contact/newsletter/unsubscribe/', { email })
  },
}
